import { render, staticRenderFns } from "./inputTable.vue?vue&type=template&id=6730c054&scoped=true"
import script from "./inputTable.vue?vue&type=script&lang=js"
export * from "./inputTable.vue?vue&type=script&lang=js"
import style0 from "./inputTable.vue?vue&type=style&index=0&id=6730c054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730c054",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QVirtualScroll});
